import React from "react";

const Pagination = ({
    currentPage,
    totalPages,
    totalItems,
    itemsPerPage,
    setItemsPerPage,
    onPageChange,
}) => {
    const getPagination = (currentPage, totalPages) => {
        const pages = [];
        const pushIfNew = (val) => {
            if (pages.length === 0 || pages[pages.length - 1] !== val) {
                pages.push(val);
            }
        };

        pushIfNew(1);

        if (totalPages <= 7) {
            for (let i = 2; i <= totalPages; i++) pushIfNew(i);
            return pages;
        }

        const sibling = 2;
        let left = Math.max(2, currentPage - sibling);
        let right = Math.min(totalPages - 1, currentPage + sibling);

        if (currentPage <= sibling + 2) {
            left = 2;
            right = Math.min(totalPages - 1, 1 + 2 * sibling + 1);
        }

        if (currentPage >= totalPages - (sibling + 1)) {
            left = Math.max(2, totalPages - (2 * sibling + 1));
            right = totalPages - 1;
        }

        if (left > 2) pushIfNew("...");
        else for (let i = 2; i < left; i++) pushIfNew(i);

        for (let i = left; i <= right; i++) pushIfNew(i);

        if (right < totalPages - 1) pushIfNew("...");
        else for (let i = right + 1; i < totalPages; i++) pushIfNew(i);

        pushIfNew(totalPages);
        return pages;
    };

    const pages = getPagination(currentPage, totalPages);

    return (
        <div className="dt-layout-row d-flex align-items-center justify-content-between">
            <div className="dt-length">
                Showing{" "}
                <select className="dt-input" value={itemsPerPage} onChange={(e) => { onPageChange(1); setItemsPerPage(Number(e.target.value)); }}  >
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                </select>{" "}
                of {totalItems} entries
            </div>

            <div className="dt-paging d-flex align-items-center" style={{ gap: "5px" }}>
                <button className="dt-paging-button previous" disabled={currentPage === 1} onClick={() => onPageChange(currentPage - 1)} >
                    Previous
                </button>

                {pages.map((p, idx) =>
                    p === "..." ? (
                        <span key={`dots-${idx}`} className="dt-paging-ellipsis">
                            ...
                        </span>
                    ) : (
                        <button key={p} className={`dt-paging-button ${currentPage === p ? "current" : ""}`} onClick={() => onPageChange(p)} >
                            {p}
                        </button>
                    )
                )}

                <button className="dt-paging-button next" disabled={currentPage === totalPages} onClick={() => onPageChange(currentPage + 1)}  >
                    Next
                </button>
            </div>
        </div>
    );
};

export default Pagination;
